import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9544_246)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.61328 0H12.3867C13.3442 0.00276118 14.2616 0.386106 14.9387 1.06629C15.6157 1.74647 15.9973 2.6682 16 3.63012V12.3712C15.9969 13.3329 15.6152 14.2543 14.9382 14.9342C14.2612 15.6141 13.344 15.9972 12.3867 16H3.61328C2.65605 15.9972 1.73879 15.6141 1.0618 14.9342C0.38481 14.2543 0.00309168 13.3329 0 12.3712V3.63012C0.00274837 2.6682 0.384315 1.74647 1.06134 1.06629C1.73837 0.386106 2.65582 0.00276118 3.61328 0Z",
			fill: "#0A66C2"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.40495 6.20339H8.42708V7.24991H8.45573C8.73828 6.74235 9.42578 6.20339 10.4531 6.20339C12.5872 6.20339 12.9818 7.5377 12.9818 9.27362V12.9443H10.8737V9.68176C10.8737 8.93481 10.8581 7.97332 9.77734 7.97332C8.69662 7.97332 8.51172 8.78568 8.51172 9.62813V12.9508H6.40495V6.20339ZM5.20833 4.16006C5.20833 4.37791 5.14403 4.59086 5.02357 4.772C4.9031 4.95313 4.73187 5.09431 4.53154 5.17768C4.3312 5.26104 4.11076 5.28286 3.89809 5.24036C3.68542 5.19786 3.49007 5.09295 3.33674 4.93891C3.18341 4.78487 3.07899 4.5886 3.03669 4.37494C2.99439 4.16128 3.0161 3.93981 3.09908 3.73855C3.18206 3.53728 3.32258 3.36525 3.50288 3.24422C3.68317 3.12319 3.89514 3.05859 4.11198 3.05859C4.40265 3.05894 4.68131 3.1751 4.88684 3.38159C5.09237 3.58808 5.20799 3.86804 5.20833 4.16006ZM3.01823 6.20339H5.20833V12.9443H3.01823V6.20339Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9544_246",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgLinkedIn;
